var React = require('react');

function IcComment (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M46 20c0-8.837-7.163-16-16-16H18C9.163 4 2 11.163 2 20s7.163 16 16 16h9.079c.19 2.237.743 4.104 1.86 5.5C30.466 43.41 32.68 44 35 44v-4c-1.68 0-2.467-.41-2.938-1-.418-.522-.798-1.438-.968-3.037C39.42 35.401 46 28.47 46 20zM30 8c6.627 0 12 5.373 12 12s-5.373 12-12 12H18c-6.627 0-12-5.373-12-12S11.373 8 18 8h12z","key":0}),React.createElement("path",{"d":"M34 18h-4v4h4zM26 18h-4v4h4zM18 18h-4v4h4z","key":1})]);
}

IcComment.defaultProps = {"fill":"currentColor","viewBox":"0 0 48 48"};

module.exports = IcComment;

IcComment.default = IcComment;
